import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { usePresentacionContext } from "../context/presentacion.context";
import TransaccionesDetalles from "./TransaccionesDetalles";
import Spinner from "../../shared/components/Spinner";
import { NumericFormat } from "react-number-format";
import {
  consultarTransaccionesAgrupadasCierreLote,
  consultarTransaccionesConDetalleMF,
  consultarTransaccionesDetalles,
  transaccionesIncluirTodo,
} from "../services/transacciones.service";
import { INICIADA_COMERCIO } from "../utilities/constants";
import {
  borrarImpuestosPresentacion,
  consultarImpuestosPresentacion,
  consultarImpuestosPresentacionAutomatica,
  consultarImpuestosPresentacionAutomaticaActualizados,
  crearImpuestosPresentacion,
} from "../services/impuestos.service";
import { TransaccionesServicio } from "../models/TransaccionesAgrupadasCierreLote.model";
import { useGlobalContext } from "../../shared/context/global.context";
import { impuestosDTOAdapterEmpty } from "../adapters/impuesto.adapter";
import TransaccionesDetallesMF from "./TransaccionesDetallesMF";
import { isCombustibleAfines } from "../utilities/utils";
import { useLocation } from "react-router";

interface Result {
  data: any | never[];
  message: string;
  error?: undefined | unknown;
}

const TransaccionesLotes = () => {
  const { userSessionModulo } = useGlobalContext();
  const {
    loadFacturaComercio,
    setLoadFacturaComercio,
    setTransaccionesDisponibles,
    setTransaccionesSeleccionadas,
    setSumTDisponibles,
    setSumTSeleccionadas,
    setDataImpuestos,
    setSpinnerImpuestosTasas,
    flagUpdateTxDisponibles,
    setFlagUpdateTxDisponibles,
    setImpuestosDefault,
    transaccionesDisponibles,
    transaccionesSeleccionadas,
    sumTDisponibles,
    sumTSeleccionadas,
    setDetailsTxDisponibles,
    setDetailsTxSeleccionadas,
    presentacion,
    presentacionEditable,
    setShowMask,
    showMask,
    selectedProductoComercio,
    detailsTxDisponibles,
    setTotalImpuestosMF,
    setPresupuestosList,
    presentacionComercio,
    showDetailTransaction,
    setShowDetailTransaction,
    flagUpdateTableImpuestosTasas
  } = usePresentacionContext();

  const [spinnerDetailsTransaction, setSpinnerDetailsTransaction] =
    useState<boolean>(false);
  const { state } = useLocation();
  let rowDataPresentacion = state ? JSON.parse(state) : presentacionComercio;

  useEffect(() => {
    (async () => {
      if (isCombustibleAfines(selectedProductoComercio.grupoProductoId)) return;

      let resultTxMF = await consultarTransaccionesConDetalleMF(
        presentacion,
        selectedProductoComercio.grupoProductoId
      );
      if (resultTxMF.status === 200) {
        let txIdList = resultTxMF.data.transaccionesSeleccionadas
          .map((item: any) => item.idPresupuesto)
          .join();
        setPresupuestosList(txIdList);
        setDetailsTxDisponibles(resultTxMF.data.transaccionesDisponibles);
        setDetailsTxSeleccionadas(resultTxMF.data.transaccionesSeleccionadas);
        setSumTDisponibles(resultTxMF.data.totalesDisponibles.total);
        setSumTSeleccionadas(resultTxMF.data.totalesSeleccionadas.total);
        setTotalImpuestosMF(resultTxMF.data.totalesSeleccionadas.impuesto);
      }

      setLoadFacturaComercio(false);
      setShowMask(false);
    })();
  }, [selectedProductoComercio]);

  useEffect(() => {
    (async () => {
      if (presentacion === 0) return;
      if (!isCombustibleAfines(selectedProductoComercio.grupoProductoId))
        return;

      const result = await consultarTransaccionesAgrupadasCierreLote(
        presentacion
      );
      if (result.status === 200) {
        const { sumTDisponibles, sumTSeleccionadas } = sumTxTotales(result);
        const { data, status } = await consultarImpuestosPresentacion(
          presentacion
        );

        if (
          status === 200 &&
          data.impuestos.length == 0 &&
          result.data.transaccionesSeleccionadas.length > 0
        ) {
          refreshTImpuestos(result);
        } else {
          if (status === 200 && data.impuestos.length >= 0) {
            setDataImpuestos(data);
          } else {
            setDataImpuestos({});
          }
        }

        setSpinnerImpuestosTasas(false);
        setSumTDisponibles(sumTDisponibles);
        setSumTSeleccionadas(sumTSeleccionadas);
        setTransaccionesDisponibles(result.data.transaccionesDisponibles);
        setTransaccionesSeleccionadas(result.data.transaccionesSeleccionadas);
      }
      setLoadFacturaComercio(false);
      setShowMask(false);
    })();
  }, [presentacion, selectedProductoComercio]);

  useEffect(() => {
    (async () => {
      setLoadFacturaComercio(false);
      if (flagUpdateTxDisponibles == -1) {
        setShowMask(false);
        return;
      }
      setShowMask(true)
      await LimpiarTablaDeclaracionDeImpuestosTasas();
      const result = await consultarTransaccionesAgrupadasCierreLote(
        presentacion
      );
      await refreshTImpuestos(result);
      setShowMask(false)
    })();
  }, [flagUpdateTxDisponibles]);

    useEffect(() => {
        (async () => {
            if (flagUpdateTableImpuestosTasas == -1) {
                setShowMask(false);
                return;
            }
            setShowMask(true)
            await LimpiarTablaDeclaracionDeImpuestosTasas();
            const result = await consultarTransaccionesAgrupadasCierreLote(
                presentacion
            );
            await refreshTImpuestos(result);
            setShowMask(false)
        })();
    }, [flagUpdateTableImpuestosTasas]);

  const refreshTImpuestos = async (result: any) => {
    if (result.status === 200) {
      const { sumTDisponibles, sumTSeleccionadas } = sumTxTotales(result);

      if (result.data.transaccionesSeleccionadas.length > 0) {
        if (userSessionModulo && rowDataPresentacion.impuestos_manual) {
          let impuestosDtoList = result.data.transaccionesSeleccionadas.map(
            (txS: TransaccionesServicio) => {
              let impuestoEmpty = impuestosDTOAdapterEmpty();
              impuestoEmpty.Litros = txS.cantidad;
              impuestoEmpty.IdServicio = txS.idServicio;
              impuestoEmpty.PreCupon = presentacion;
              return impuestoEmpty;
            }
          );

          if (impuestosDtoList.length > 0) {
            let model = {
              PreCupon: presentacion,
              ListaImpuestos: impuestosDtoList,
            };
            const resultCreateImpuestos = await crearImpuestosPresentacion(
              model
            );
            if (resultCreateImpuestos.status === 200) {
              const { data, status } = await consultarImpuestosPresentacion(
                presentacion
              );
              if (status === 200) {
                setDataImpuestos(data);
              }
            }
          }
        } else {
          let impuestosDtoList = result.data.transaccionesSeleccionadas.map(
            (txS: TransaccionesServicio) => {
              let impuestoEmpty = impuestosDTOAdapterEmpty();
              impuestoEmpty.Litros = txS.cantidad;
              impuestoEmpty.IdServicio = txS.idServicio;
              impuestoEmpty.PreCupon = presentacion;
              return impuestoEmpty;
            }
          );
          if (impuestosDtoList.length > 0) {
            let impuestosPresentacionRequest = {
              PreCupon: presentacion,
              ListaImpuestos: impuestosDtoList,
            };
            const resultCreateImpuestos = await crearImpuestosPresentacion(
              impuestosPresentacionRequest
            );

            const resultImpuestosDefault =
              await consultarImpuestosPresentacionAutomatica(presentacion);
            if (resultImpuestosDefault.status === 200) {
              setImpuestosDefault(resultImpuestosDefault.data.impuestos);
            }

            if (resultCreateImpuestos.status === 200) {
              const resultImpuestoPresentacion =
                await consultarImpuestosPresentacionAutomaticaActualizados(
                  presentacion
                );
              if (resultImpuestoPresentacion.status === 200) {
                setDataImpuestos(resultImpuestoPresentacion.data);
              }
            }
          }
        }
        setSpinnerImpuestosTasas(false);
        /*end impuestos*/
        setSumTDisponibles(sumTDisponibles);
        setSumTSeleccionadas(sumTSeleccionadas);
        setTransaccionesDisponibles(result.data.transaccionesDisponibles);
        setTransaccionesSeleccionadas(result.data.transaccionesSeleccionadas);
      } else {
        setTransaccionesDisponibles(result.data.transaccionesDisponibles);
        setTransaccionesSeleccionadas(result.data.transaccionesSeleccionadas);
        setSpinnerImpuestosTasas(false);
        setImpuestosDefault([]);
        setDataImpuestos({});
      }
    }
  };

  function sumTxTotales(result: any) {
    const sumTDisponibles = result.data.transaccionesDisponibles.reduce(
      (acc: number, curr: any) => acc + (curr.monto || 0),
      0
    );
    const sumTSeleccionadas = result.data.transaccionesSeleccionadas.reduce(
      (acc: any, curr: any) => {
        if (curr.monto) {
          return acc + curr.monto;
        }
        return acc;
      },
      0
    );
    return { sumTDisponibles, sumTSeleccionadas };
  }

  const LimpiarTablaDeclaracionDeImpuestosTasas = async () => {
    let { data, status } = await borrarImpuestosPresentacion(presentacion);
    if (status === 200) {
      //fetch para Actualizar la tabla de impuestos
    }
  };

  const onClickSelectionAll = async () => {
    /***
    * incluye todas las Tx
    * luego trae el detalle de Tx
    ***/
    setLoadFacturaComercio(true);
    let body = {};
    body = {
      preCupon: presentacion,
      idAfiliado: 0,
      vog_code: selectedProductoComercio.grupoProductoId,
    };
    const { data, status } = await transaccionesIncluirTodo(body);
    if (status === 200) {
      await onclickDetailTransactions(false);
      setLoadFacturaComercio(false);
    } else {
      setLoadFacturaComercio(false);
    }
  };

  const onclickDetailTransactions = async (mostrarDetalles: boolean) => {
    if (isCombustibleAfines(selectedProductoComercio.grupoProductoId)) {
      /*** 
       * consulta el detalle de las Tx,
       * actualizar el context global
       ***/
      mostrarDetalles && setSpinnerDetailsTransaction(true);
      setShowMask(true);
      let resultDetailsTransacction;
      if ( window.location.href.indexOf("presentacion=") > 0 && !showDetailTransaction) {
        let presentacion = window.location.href.split("=")[1];
        resultDetailsTransacction = await consultarTransaccionesDetalles(parseInt(presentacion));
      }else{
        resultDetailsTransacction = await consultarTransaccionesDetalles(presentacion);
      }

      if (resultDetailsTransacction.status === 200) {
        setDetailsTxDisponibles(
          resultDetailsTransacction.data.transaccionesDisponibles
        );
        setDetailsTxSeleccionadas(
          resultDetailsTransacction.data.transaccionesSeleccionadas
        );
      }
      if (!mostrarDetalles) {
        setFlagUpdateTxDisponibles(
          (prevFlagUpdateTxDisponibles: any) =>
            prevFlagUpdateTxDisponibles + 1
        );
      }else{
        setShowMask(false);
      }

      setSpinnerDetailsTransaction(false);
      
      if (mostrarDetalles) {
        setShowDetailTransaction(true);
      }
    } else {
      mostrarDetalles && setSpinnerDetailsTransaction(true);
      setShowMask(true);
      let resultTxMF = await consultarTransaccionesConDetalleMF(
        presentacion,
        selectedProductoComercio.grupoProductoId
      );
      if (resultTxMF.status === 200) {
        let txIdList = resultTxMF.data.transaccionesSeleccionadas
          .map((item: any) => item.idPresupuesto)
          .join();
        setPresupuestosList(txIdList);
        setDetailsTxDisponibles(resultTxMF.data.transaccionesDisponibles);
        setDetailsTxSeleccionadas(resultTxMF.data.transaccionesSeleccionadas);
        setSumTDisponibles(resultTxMF.data.totalesDisponibles.total);
        setSumTSeleccionadas(resultTxMF.data.totalesSeleccionadas.total);
        setTotalImpuestosMF(resultTxMF.data.totalesSeleccionadas.impuesto);
      }
      setSpinnerDetailsTransaction(false);
      setShowMask(false);
      if (mostrarDetalles) {
        setShowDetailTransaction(true);
      }
    }
  };

  const renderHeader = (title: string, total: number) => {
    return (
      <div className="p-grid">
        <div className="p-col-12 p-md-10 p-lg-9" style={{ textAlign: "left" }}>
          <p className="t4">{title}</p>
        </div>
        <div className="p-col-12 p-md-2 p-lg-3">
          <NumericFormat
            value={total}
            displayType={"text"}
            thousandSeparator={"."}
            decimalSeparator={","}
            prefix={"$"}
            decimalScale={2}
            fixedDecimalScale={true}
          />
        </div>
      </div>
    );
  };
  const renderFooter = () => {
    return (
      !loadFacturaComercio &&
      transaccionesDisponibles.length > 0 && (
        <div className="p-grid p-justify-center mb-2 mt-2">
          <div className="button-demo">
            <div className="template">
              <Button
                className="twitter p-0"
                aria-label="Twitter"
                onClick={onClickSelectionAll}
                style={{ minWidth: "150px" }}
              >
                <i className="pi pi-angle-right p-pl-2"></i>
                <span className="px-3">Incluir Todos</span>
              </Button>
            </div>
          </div>
        </div>
      )
    );
  };

  const totalSinDescuentoBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <NumericFormat
          value={rowData.montoSinDescuento}
          displayType={"text"}
          thousandSeparator={"."}
          decimalSeparator={","}
          prefix={"$"}
          decimalScale={2}
          fixedDecimalScale={true}
        />
      </React.Fragment>
    );
  };
  const totalBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <NumericFormat
          value={rowData.monto}
          displayType={"text"}
          thousandSeparator={"."}
          decimalSeparator={","}
          prefix={"$"}
          decimalScale={2}
          fixedDecimalScale={true}
        />
      </React.Fragment>
    );
  };

  return (
    <>
      <div className="p-grid p-justify-between ">
        {presentacionComercio.descripcion === INICIADA_COMERCIO && (
          <div className="p-col-12 p-lg-6 ">
            <div>
              {
                <div className="card">
                  {isCombustibleAfines(
                    selectedProductoComercio.grupoProductoId
                  ) ? (
                    <DataTable
                      header={() =>
                        renderHeader(
                          "Disponibles para facturar",
                          sumTDisponibles
                        )
                      }
                      responsiveLayout="stack"
                      size="small"
                      value={transaccionesDisponibles}
                      loading={loadFacturaComercio}
                      className="txDataTable"
                      footer={
                        presentacionEditable ? () => renderFooter() : <></>
                      }
                    >
                      <Column
                        field="descripcionServicio"
                        header="Producto"
                        style={{ width: "25%" }}
                      ></Column>
                      <Column
                        field="cantidad"
                        header="Cantidad"
                        style={{ textAlign: "right", width: "25%" }}
                      ></Column>
                      <Column
                        field="montoSinDescuento"
                        header="Total sin descuento"
                        body={totalSinDescuentoBodyTemplate}
                        style={{ textAlign: "right", width: "25%" }}
                      ></Column>
                      <Column
                        field="monto"
                        header="Total"
                        body={totalBodyTemplate}
                        style={{ textAlign: "right", width: "25%" }}
                      ></Column>
                    </DataTable>
                  ) : (
                    renderHeader("Disponibles para facturar", sumTDisponibles)
                  )}
                </div>
              }
              {!isCombustibleAfines(selectedProductoComercio.grupoProductoId) &&
                detailsTxDisponibles.length > 0 && (
                  <div className="p-col-12 p-md-6">
                    <div className="button-demo">
                      <div className="template">
                        <Button
                          className="twitter p-0"
                          aria-label="Twitter"
                          onClick={onClickSelectionAll}
                          style={{ minWidth: "150px" }}
                        >
                          <i className="pi pi-angle-right p-pl-2"></i>
                          <span className="px-3">Incluir Todo </span>
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        )}
        <div
          className={
            presentacionComercio.descripcion === INICIADA_COMERCIO
              ? "p-col-12 p-lg-6 "
              : "p-col-12"
          }
        >
          <div>
            <div className="card">
              {loadFacturaComercio && <Spinner />}
              {isCombustibleAfines(selectedProductoComercio.grupoProductoId) ? (
                <DataTable
                  header={() =>
                    renderHeader(
                      "Seleccionadas para facturar",
                      sumTSeleccionadas
                    )
                  }
                  responsiveLayout="stack"
                  size="small"
                  value={transaccionesSeleccionadas}
                  loading={loadFacturaComercio}
                  className="txDataTable"
                  footer={<></>}
                >
                  <Column
                    field="descripcionServicio"
                    header="Producto"
                    style={{ width: "25%" }}
                  ></Column>
                  <Column
                    field="cantidad"
                    header="Cantidad"
                    style={{ textAlign: "right", width: "25%" }}
                  ></Column>
                  <Column
                    field="montoSinDescuento"
                    header="Total sin descuento"
                    body={totalSinDescuentoBodyTemplate}
                    style={{ textAlign: "right", width: "25%" }}
                  ></Column>
                  <Column
                    field="monto"
                    header="Total"
                    body={totalBodyTemplate}
                    style={{ textAlign: "right", width: "25%" }}
                  ></Column>
                </DataTable>
              ) : (
                renderHeader("Seleccionadas para facturar", sumTSeleccionadas)
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="p-grid p-justify-center mb-2 mt-2">
        <div className="button-demo">
          <div className="template">
            {showDetailTransaction ? (
              <Button
                className="twitter p-0"
                aria-label="Twitter"
                onClick={() => setShowDetailTransaction(false)}
                disabled={showMask || loadFacturaComercio}
              >
                <i className="pi pi-chevron-up px-2"></i>
                <span className="px-3">Ocultar Detalle Transacciones</span>
              </Button>
            ) : (
              <Button
                className="twitter p-0"
                aria-label="Twitter"
                onClick={() => onclickDetailTransactions(true)}
                disabled={showMask || loadFacturaComercio}
              >
                {spinnerDetailsTransaction ? (
                  <div style={{ width: "38px", backgroundColor: "#3b82f6" }}>
                    <i className="pi pi-spin pi-spinner"></i>
                  </div>
                ) : (
                  <i className="pi pi-chevron-down px-2"></i>
                )}
                <span className="px-3">Mostrar Detalle Transacciones</span>
              </Button>
            )}
          </div>
        </div>
      </div>

      <div className="p-grid p-justify-center p-align-center">
        <div className="p-col-12">
          {showDetailTransaction &&
            isCombustibleAfines(selectedProductoComercio.grupoProductoId) && (
              <TransaccionesDetalles setMask={setShowMask} />
            )}
          {showDetailTransaction &&
            !isCombustibleAfines(selectedProductoComercio.grupoProductoId) && (
              <TransaccionesDetallesMF setMask={setShowMask} />
            )}
        </div>
      </div>
    </>
  );
};

export default TransaccionesLotes;
